// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce94434d","453":"05a18653","667":"84d97535"}[chunkId] + ".chunk.js";
};